import { Component, input } from '@angular/core';
import { NodeProcov } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ProductLayoutComponent } from '@app/components/product/product-layout/product-layout.component';

@Component({
  selector: 'mobi-node-procov',
  templateUrl: './node-procov.component.html',
  styleUrls: ['./node-procov.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, ProductLayoutComponent],
})
export class NodeProcovComponent {
  readonly entity = input.required<NodeProcov>();
}
